/** Необязательные поля игрока, по которым считается заполненность формы. */
export interface PlayerFormOptionalFields {
  middleName?: string | null;
  birthDate?: string | null;
  photo?: unknown;
  height?: number | null;
  weight?: number | null;
}

// `type`, а не `interface`: свойства события уходят в `trackEvent` как `Record<string, unknown>`, а интерфейс без
// индексной сигнатуры ему не присваивается.
export type PlayerFormCompleteness = {
  has_middle_name: boolean;
  has_birth_date: boolean;
  has_photo: boolean;
  has_height: boolean;
  has_weight: boolean;
};

/**
 * Заполненность формы игрока для `Player Created` — только «заполнено / нет», без самих значений (без PII).
 * Общая для трёх мест создания игрока, чтобы набор свойств не разошёлся. Поля, которых в форме нет (быстрое
 * добавление в карточке команды без фото и роста), честно уходят `false`.
 *
 * Импортировать из этого файла, а не из `shared/analytics`: тесты форм мокают `shared/analytics` целиком.
 */
export function buildPlayerFormCompleteness(fields: PlayerFormOptionalFields): PlayerFormCompleteness {
  return {
    has_middle_name: Boolean(fields.middleName?.trim()),
    has_birth_date: Boolean(fields.birthDate),
    has_photo: Boolean(fields.photo),
    has_height: fields.height !== undefined && fields.height !== null,
    has_weight: fields.weight !== undefined && fields.weight !== null,
  };
}
